import Welcome from "@/views/Authentication/Welcome";
import Login from "@/views/Authentication/Login";
import Logout from "@/views/Authentication/Logout";
import AuthenticateLogin from "@/views/Authentication/AuthenticateLogin";
import SelectCompany from "@/views/Authentication/SelectCompany";
import Onboarding from "@/views/Authentication/Onboarding";

export default [
  {
    path: "/welcome",
    name: "Welcome",
    component: Welcome,
    meta: { authRoute: true },
  },
  {
    path: "/sign-in",
    name: "Login",
    component: Login,
    meta: { authRoute: true },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: { authRoute: true },
  },
  {
    path: "/authenticate-login",
    name: "AuthenticateLogin",
    component: AuthenticateLogin,
    meta: { authRoute: true },
  },
  {
    path: "/select-company",
    name: "SelectCompany",
    component: SelectCompany,
    meta: { authRoute: true },
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: Onboarding,
    meta: { authRoute: true },
  },
];
